var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUaeFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5121_30055)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5121_30055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 0H-12V48H84V0Z",
    fill: "#00843D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 16H-12V48H84V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 32H-12V48H84V32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0H-12V48H12V0Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5121_30055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5121_30055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 48,
    fill: "white",
    transform: "translate(-12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/uae-flag.7e855f9643ad1772d813b49239eb6757.svg";
export { ForwardRef as ReactComponent };